import translate from '@/utils/translate';

const CREATOR_ISSUE_MESSAGES: Record<string, string> = {
  auth_failed: 'Creator needs to re-link their social account',
  profile_not_found: 'Creator profile not found',
};

const DEFAULT_FAILURE_MESSAGE =
  'The vetting report failed to generate. You can retry by clicking the "Rescan" button.';

export default function getFailureReasonTooltip(
  failureReason?: string
): string {
  if (failureReason && CREATOR_ISSUE_MESSAGES[failureReason]) {
    return translate(CREATOR_ISSUE_MESSAGES[failureReason]) as string;
  }
  return translate(DEFAULT_FAILURE_MESSAGE) as string;
}
